import { createApp } from "vue";
import * as Sentry from "../../sentry/sentry.js";
import App from "./App.vue";
import "./tailwind.css";

const app = createApp(App);
Sentry.init(app, undefined);
app.mount("#app");
